import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from './Spinner';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  // If there is no token, redirect to login page.
  if (!token) {
    return (
      <>
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(255,255,255,0.85)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}>
          <Spinner />
          <p style={{ marginTop: 12, color: '#333' }}>Redirecting to Login…</p>
        </div>
        <Navigate to="/login" state={{ from: location }} replace />
      </>
    );
  }

  // If there is a token, show the page the user wanted to see.
  return children;
};

export default ProtectedRoute;